import { UnleashClient as _ } from "unleash-proxy-client";
import { InMemoryStorageProvider as J, LocalStorageProvider as Q, UnleashClient as W } from "unleash-proxy-client";
import * as d from "react";
import k, { useContext as i, useState as h, useRef as R, useEffect as E } from "react";
const f = k.createContext(null), A = {
  bootstrap: [],
  disableRefresh: !0,
  disableMetrics: !0,
  url: "http://localhost",
  appName: "offline",
  clientKey: "not-used"
}, C = "startTransition", v = d[C] || ((e) => e()), O = ({
  config: e,
  children: t,
  unleashClient: n,
  startClient: s = !0
}) => {
  const c = e || A, r = d.useRef(
    n || new _(c)
  ), [l, u] = d.useState(
    !!(n ? e != null && e.bootstrap && (e == null ? void 0 : e.bootstrapOverride) !== !1 : c.bootstrap && c.bootstrapOverride !== !1)
  ), [o, b] = d.useState(null);
  d.useEffect(() => {
    !c && !n && console.error(
      `You must provide either a config or an unleash client to the flag provider.
        If you are initializing the client in useEffect, you can avoid this warning
        by checking if the client exists before rendering.`
    );
    const a = (y) => {
      v(() => {
        b((U) => U || y);
      });
    }, g = (y) => {
      v(() => {
        b(null);
      });
    };
    let p;
    const x = () => {
      p = setTimeout(() => {
        v(() => {
          u(!0);
        });
      }, 0);
    };
    return r.current.on("ready", x), r.current.on("error", a), r.current.on("recovered", g), (s || !n) && (r.current.stop(), r.current.start()), function() {
      r.current && (r.current.off("error", a), r.current.off("ready", x), r.current.off("recovered", g), r.current.stop()), p && clearTimeout(p);
    };
  }, []);
  const F = async (a) => {
    await r.current.updateContext(a);
  }, S = (a) => r.current.isEnabled(a), m = (a) => r.current.getVariant(a), T = (a, g, p) => r.current.on(a, g, p), H = d.useMemo(
    () => ({
      on: T,
      updateContext: F,
      isEnabled: S,
      getVariant: m,
      client: r.current,
      flagsReady: l,
      flagsError: o,
      setFlagsReady: u,
      setFlagsError: b
    }),
    [l, o]
  );
  return /* @__PURE__ */ d.createElement(f.Provider, { value: H }, t);
}, z = (e) => {
  const { isEnabled: t, client: n } = i(f), [s, c] = h(!!t(e)), r = R();
  return r.current = s, E(() => {
    if (!n)
      return;
    const l = () => {
      const o = t(e);
      o !== r.current && (r.current = o, c(!!o));
    }, u = () => {
      const o = t(e);
      r.current = o, c(o);
    };
    return n.on("update", l), n.on("ready", u), () => {
      n.off("update", l), n.off("ready", u);
    };
  }, [n]), s;
}, B = () => {
  const { client: e } = i(f), [t, n] = h(e.getAllToggles());
  return E(() => {
    const s = () => {
      n(e.getAllToggles());
    };
    return e.on("update", s), () => {
      e.off("update", s);
    };
  }, []), t;
}, K = () => {
  const { flagsReady: e, flagsError: t } = i(f);
  return { flagsReady: e, flagsError: t };
}, P = (e, t) => {
  var s, c, r, l;
  return !(e.name === (t == null ? void 0 : t.name) && e.enabled === (t == null ? void 0 : t.enabled) && e.feature_enabled === (t == null ? void 0 : t.feature_enabled) && ((s = e.payload) == null ? void 0 : s.type) === ((c = t == null ? void 0 : t.payload) == null ? void 0 : c.type) && ((r = e.payload) == null ? void 0 : r.value) === ((l = t == null ? void 0 : t.payload) == null ? void 0 : l.value));
}, L = (e) => {
  const { getVariant: t, client: n } = i(f), [s, c] = h(t(e)), r = R({
    name: s.name,
    enabled: s.enabled
  });
  return r.current = s, E(() => {
    if (!n)
      return;
    const l = () => {
      const o = t(e);
      P(r.current, o) && (c(o), r.current = o);
    }, u = () => {
      const o = t(e);
      r.current.name = o == null ? void 0 : o.name, r.current.enabled = o == null ? void 0 : o.enabled, c(o);
    };
    return n.on("update", l), n.on("ready", u), () => {
      n.off("update", l), n.off("ready", u);
    };
  }, [n]), s || {};
}, Y = () => {
  const { updateContext: e } = i(f);
  return e;
}, j = () => {
  const { client: e } = i(f);
  return e;
};
export {
  f as FlagContext,
  O as FlagProvider,
  J as InMemoryStorageProvider,
  Q as LocalStorageProvider,
  W as UnleashClient,
  O as default,
  z as useFlag,
  B as useFlags,
  K as useFlagsStatus,
  j as useUnleashClient,
  Y as useUnleashContext,
  L as useVariant
};
//# sourceMappingURL=unleash-react.js.map
